import React from "react";
import { connect } from "react-redux";
import {
  getArticles,
  getCategories,
  removeArticle,
  createArticle
} from "../../actions/catadvs";
import { subArticle } from "../../actions/sub";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  Button,
  Modal,
  UncontrolledAlert
} from "reactstrap";
import qs from "query-string";
import ReactBSAlert from "react-bootstrap-sweetalert";
import DropdownSelection from "../../components/Commons/DropdownSelection";
import SearchBar from "../../components/Commons/SearchBar";
import ArticleTable from "../../components/catadvs/ArticleTable";
import PaginationBar from "../../components/Commons/PaginationBar";
import NewModal from "../../components/catadvs/NewModal";

class FreelancerPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      per_page: 7,
      alert: "",
      openUserModal: false,
      selectedUser: {},
      activeCategoryType: null,
      selects: {},
      operationModal: false,
      article: {
        category_ids: [96],
        type: "right",
        vacancy_weeks: 1
      },
      operationNewModal: false
    };
    this.goToPage = this.goToPage.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.filterCat = this.filterCat.bind(this);
    this.filterAuthor = this.filterAuthor.bind(this);
    this.getCurrentCategory = this.getCurrentCategory.bind(this);
    this.removeArticle = this.removeArticle.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.toggleSelectEvent = this.toggleSelectEvent.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.togglemark = this.togglemark.bind(this);
    this.toggleNewModal = this.toggleNewModal.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
    this.onTextInputChange = this.onTextInputChange.bind(this);
  }

  componentDidMount() {
    let urlParams = qs.parse(this.props.search);
    // let { category_id } = urlParams;
    // const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      ...this.state,
      ...urlParams
      // activeCategoryType: activeCategoryType
    });
    this.getCategories();
    this.getArticles({ ...urlParams });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      console.log("Route Updated");
      let urlParams = qs.parse(this.props.search);
      this.getArticles(urlParams);
    }

    if (this.props.catadvs.categories !== prevProps.catadvs.categories) {
      let urlParams = qs.parse(this.props.search);
      let { category_id } = urlParams;
      const activeCategoryType = this.getCurrentCategory(category_id);

      this.setState({
        activeCategoryType
      });
    }
  }

  // componentWillReceiveProps(newProps) {
  //   if (newProps.location !== this.props.location) {
  //     let urlParams = qs.parse(newProps.search);
  //     this.getArticles(urlParams);
  //   }
  //   if (newProps.catadvs !== this.props.catadvs) {
  //     let urlParams = qs.parse(newProps.search);
  //     let { category_id } = urlParams;
  //     const activeCategoryType = this.getCurrentCategory(category_id);
  //     this.setState({
  //       activeCategoryType
  //     });
  //   }
  // }

  getCurrentCategory(category_id) {
    let { categories } = this.props.catadvs;
    var matchRoles = categories.filter(value => {
      return value.id == category_id;
    });
    var activeCategoryType = null;
    if (matchRoles.length) {
      activeCategoryType = matchRoles[0].display_name;
    }
    return activeCategoryType;
  }

  getCategories() {
    this.props.getCategories();
  }

  hideAlert() {
    this.setState({
      alert: ""
    });
  }

  confirmedRemove(row) {
    this.setState({
      alert: ""
    });
    let post_id = row.post.id;
    this.props.removeArticle({ post_id });
  }

  removeArticle(row) {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          title={`刪除文章 ${row.post.title}?`}
          style={{ backgroundColor: "#ffffff" }}
          onCancel={() => this.hideAlert()}
          onConfirm={() => this.confirmedRemove(row)}
          showCancel
          cancelBtnBsStyle="default"
          cancelBtnText="取消"
          confirmBtnBsStyle="primary"
          confirmBtnText="是的，刪除！"
          btnSize=""
        >
          <small>刪除操作將無法取消</small>
        </ReactBSAlert>
      )
    });
  }

  getArticles(params) {
    // let urlParams = qs.parse(this.props.search);
    let searchParams = {
      // ...urlParams,
      ...params
    };
    this.props.getArticles(searchParams);
  }

  goToPage(page) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      page
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  filterCat(category_id) {
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      activeCategoryType: activeCategoryType
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      category_id
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  filterAuthor(author_id) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      author_id
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  onSearchInputChange(e) {
    let searchStr = e.target.value;
    this.setState({
      title: searchStr
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      title: searchStr,
      page: 1
    };
    delete searchParams.page;
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  toggleSelectEvent(checked, index) {
    let selects = this.state.selects;
    selects[index] = checked;
    this.setState({
      selects
    });
  }

  toggleModal = state => {
    this.setState({
      operationModal: !this.state.operationModal
    });
  };

  togglemark() {
    let selects = this.state.selects;
    let post_category_join_ids = [];
    Object.keys(selects).forEach(function(key) {
      if (selects[key]) {
        post_category_join_ids.push(parseInt(key));
      }
    });
    let type = "is_push_selected";
    let mark = 1;
    this.props.subArticle({
      type,
      mark,
      post_category_join_ids
    });
    this.setState({
      operationModal: !this.state.operationModal,
      selects: []
    });
  }

  toggleNewModal = state => {
    this.setState({
      operationNewModal: !this.state.operationNewModal
    });
  };

  submitArticle() {
    let { article } = this.state;
    const category_id = article.category_ids[0];
    const position = article.type;
    const weeks = article.vacancy_weeks;
    let path = "admin";
    let status = "draft";
    this.props.createArticle({
      category_id,
      position,
      weeks,
      path,
      status
    });
  }

  handleCheckBoxChange(e) {
    const { value } = e.target;
    let article = this.state.article;
    let category_ids = [];
    category_ids.push(parseInt(value));
    this.setState({
      article: {
        ...article,
        category_ids
      }
    });
  }

  onTextInputChange(e, target) {
    let value = e.target.value;
    let article = this.state.article;
    article[target] = value;
    this.setState({
      article: article
    });
  }

  render() {
    const {
      articles,
      articlesPagination,
      getArticlesRequest,
      categories,
      errorMsg,
      successBackMsg,
      editArticleRequest
    } = this.props.catadvs;
    var activeCategoryType = this.state.activeCategoryType;

    const heads = [
      "狀態",
      "標題",
      "位置",
      "分類",
      "金額",
      "購買日期",
      "到期日期",
      "操作"
    ];
    const dataAttributes = [
      "status",
      "title",
      "category",
      "author",
      "created_at"
    ];

    return (
      <Container className="mt-4" fluid>
        {this.state.alert}
        {errorMsg && (
          <UncontrolledAlert color="danger" fade={false}>
            <span className="alert-inner--text mb-4">{errorMsg}</span>
          </UncontrolledAlert>
        )}
        {successBackMsg && (
          <UncontrolledAlert color="success" fade={false}>
            <span className="alert-inner--text mb-4">{successBackMsg}</span>
          </UncontrolledAlert>
        )}
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between"></div>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <DropdownSelection
                  Types={categories}
                  activeType={activeCategoryType}
                  filterType={this.filterCat}
                />
              </div>
              <div className="d-flex align-items-center">
                <SearchBar
                  search_string={this.state.title}
                  onSearchInputChange={this.onSearchInputChange}
                />
                <Button
                  className="btn btn-default"
                  onClick={this.toggleNewModal}
                >
                  添加廣告
                </Button>
              </div>
            </div>
          </CardHeader>
          <ArticleTable
            heads={heads}
            dataAttributes={dataAttributes}
            rows={articles}
            loading={getArticlesRequest}
            remove={this.removeArticle}
            toggleSingle={this.toggleSelectEvent}
            selects={this.state.selects}
            toggleModal={this.toggleModal}
          />
          <CardFooter className="py-4 d-flex justify-content-center">
            {articlesPagination.currentPage ? (
              <PaginationBar
                currentPage={articlesPagination.currentPage}
                totalPages={articlesPagination.lastPage}
                pageNeighbours={1}
                goToPage={page => this.goToPage(page)}
              />
            ) : null}
          </CardFooter>
        </Card>
        <Modal
          className="modal-dialog-centered modal-sm"
          isOpen={this.state.operationModal}
          toggle={() => this.toggleModal()}
        >
          <div className="modal-header">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal()}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body d-flex flex-column justify-content-center align-items-center">
            {this.props.sub.errorMsg}
            <Button
              color="default"
              outline
              type="button"
              onClick={this.togglemark}
            >
              添加到訂閱推送
            </Button>
          </div>
        </Modal>
        <NewModal
          user={this.props.user}
          categories={categories}
          data={this.state.article}
          handleCheckBoxChange={this.handleCheckBoxChange}
          submitArticle={this.submitArticle}
          loading={editArticleRequest}
          toggleNewModal={this.toggleNewModal}
          operationNewModal={this.state.operationNewModal}
          onTextInputChange={this.onTextInputChange}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.selectedUser,
    catadvs: state.catadvs,
    sub: state.sub,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getArticles: params => dispatch(getArticles(params)),
    getCategories: params => dispatch(getCategories(params)),
    removeArticle: params => dispatch(removeArticle(params)),
    createArticle: params => dispatch(createArticle(params)),
    subArticle: params => dispatch(subArticle(params))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FreelancerPage);
